import { useState } from 'react';

const faqList = [
  {
    q: 'Что такое командообразование?',
    a: 'Командообразование — это системная работа по развитию доверия, коммуникации, ответственности и эффективности внутри команды. В отличие от развлекательного тимбилдинга, командообразование направлено на реальные бизнес-результаты и меняет культуру взаимодействия.',
  },
  {
    q: 'Что такое тимбилдинг?',
    a: 'Тимбилдинг (team building) — это мероприятия, направленные на сплочение коллектива, развитие командного духа и улучшение взаимодействия между сотрудниками. Это может быть как развлекательный формат (квесты, пейнбол), так и профессиональный (бизнес-игры, тренинги).',
  },
  {
    q: 'Чем отличается тимбилдинг от командообразования?',
    a: 'Тимбилдинг — это чаще развлекательные мероприятия: квесты, пейнбол, боулинг, корпоративы. Они дают хорошее настроение, но редко меняют реальные отношения в команде. Командообразование — это системная работа, которая меняет отношения, правила взаимодействия, ценности, способы коммуникации, ответственность и культуру команды.',
  },
  {
    q: 'Когда компании нужен тимбилдинг?',
    a: 'Тимбилдинг и командообразование нужны при росте компании, слиянии команд, смене руководства, высокой текучести кадров, конфликтах между отделами, низкой вовлеченности, при необходимости внедрения изменений и формировании корпоративной культуры.',
  },
  {
    q: 'Как проходит корпоративное командообразование?',
    a: 'Процесс включает 7 этапов: диагностика ситуации и целей, постановка измеримых задач, подготовка индивидуальной программы, проведение тренинга или бизнес-игры с живым взаимодействием, глубокий разбор результатов и инсайтов, разработка плана внедрения в рабочую среду, и поддержка на этапе внедрения с корректировками.',
  },
  {
    q: 'Сколько длится программа командообразования?',
    a: 'Однодневный интенсивный тренинг или бизнес-игра — 6-8 часов. Комплексная программа развития команды — от 1 до 3 месяцев с несколькими модулями, домашними заданиями и сопровождением. Длительность определяется после диагностики под задачи компании.',
  },
  {
    q: 'Что лучше — бизнес-игра или тренинг?',
    a: 'Бизнес-игры лучше для быстрого сплочения, выявления скрытых проблем в команде и создания единого опыта. Тренинги лучше для системного развития конкретных навыков: коммуникации, переговоров, управления конфликтами. Часто оптимален комбинированный формат: бизнес-игра для диагностики и сплочения, затем тренинг для развития навыков.',
  },
  {
    q: 'Можно ли провести командообразование онлайн?',
    a: 'Да, онлайн-формат работает для распределенных команд и удаленных сотрудников. Используются виртуальные бизнес-игры, онлайн-фасилитация, командные проекты в цифровой среде и стратегические сессии через видеоконференции. Эффективность онлайн-формата подтверждена практикой с компаниями из разных стран.',
  },
  {
    q: 'Как оценить результат командообразования?',
    a: 'Результаты измеряются по нескольким параметрам: улучшение коммуникации, рост вовлеченности сотрудников, снижение текучести, ускорение принятия решений, снижение количества конфликтов, рост производительности и улучшение бизнес-показателей. Диагностика проводится до и после программы для объективной оценки изменений.',
  },
  {
    q: 'Для каких компаний подходит командообразование?',
    a: 'Командообразование подходит компаниям от 20 до 1000+ сотрудников из любых отраслей: производство, ритейл, IT, банки, логистика, медицина, строительство, услуги. Каждая программа адаптируется под специфику компании, культуру и текущие задачи.',
  },
  {
    q: 'Что получают руководители от командообразования?',
    a: 'Руководители получают сильную команду, которая самостоятельно решает задачи, меньше конфликтует, быстрее адаптируется к изменениям и берет ответственность за результат. Освобождается время руководителя от микроменеджмента и разбора конфликтов. Руководитель учится вести команду через доверие, а не через контроль.',
  },
  {
    q: 'Как заказать программу командообразования?',
    a: 'Заполните заявку на сайте или свяжитесь по телефону. Мы проведем диагностику, определим цели и подготовим индивидуальную программу под задачи вашей компании. Программа включает подготовку, проведение и сопровождение внедрения результатов.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Часто задаваемые вопросы о командообразовании
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы о командообразовании, тимбилдинге и корпоративном обучении
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}